module.exports = __webpack_public_path__ + "img/40_38_090_970.14fd63f8.jpg";